// ADV-MKT-ALERT-TIMESTAMP-AUDIO-SMS-001 — short BUY CANDIDATE chime via the Web Audio API.
// No asset file: a brief two-note rising beep (<0.4s, not a siren). Best-effort under browser
// autoplay restrictions (wrapped in try/catch). Exposes a test-visible call counter.
let _ctx: AudioContext | null = null;
function _getCtx(): AudioContext | null {
  try {
    const AC = (window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext }).AudioContext
      || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return null;
    if (!_ctx) _ctx = new AC();
    return _ctx;
  } catch { return null; }
}

/** Play the BUY CANDIDATE chime once. Increments window.__adversynBuyChimes (test hook). */
export function playBuyChime(): void {
  try { (window as unknown as { __adversynBuyChimes?: number }).__adversynBuyChimes = ((window as unknown as { __adversynBuyChimes?: number }).__adversynBuyChimes || 0) + 1; } catch { /* ignore */ }
  const ctx = _getCtx();
  if (!ctx) return;
  try {
    if (ctx.state === 'suspended') { void ctx.resume(); }
    const now = ctx.currentTime;
    [880, 1320].forEach((freq, i) => { // A5 -> E6 short rising chime
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t0 = now + i * 0.12;
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.18, t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.14);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(t0); osc.stop(t0 + 0.16);
    });
  } catch { /* autoplay blocked / unsupported — counter already bumped */ }
}

/** Best-effort resume of the audio context on a user gesture (satisfies autoplay policy). */
export function primeAudio(): void {
  const ctx = _getCtx();
  try { if (ctx && ctx.state === 'suspended') void ctx.resume(); } catch { /* ignore */ }
}
